import { AttachmentFile } from '@billy/design-system'

import { Origin } from '../../enums/origin'
import { FileWithOrigin } from '../../types/fileWithOrigin'
import { deleteRequest, postFileRequest } from '../../utils'

export interface UploadFileResponseData {
  files: AttachmentFile[]
}

export const uploadProfilePic = (file: File): Promise<UploadFileResponseData> => {
  const updatedFile: FileWithOrigin = file
  updatedFile.origin = Origin.Web

  return postFileRequest('/v2/user/profilePic', updatedFile, {})
}

export const deleteProfilePic = (): Promise<UploadFileResponseData> => {
  return deleteRequest('/v2/user/profilePic')
}
